// axios
import {message} from "antd"
import axios from "axios"
import qs from 'qs'
import {GetBaseUrl} from '@/utils'

const {jwtToken = ''} = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
})

/**
 * 创建axios实例
 */
const requestAxios = axios.create({
  baseURL: GetBaseUrl(),
  timeout: 60000,
  timeoutErrorMessage: '网络请求超时！',
  params: {
    ts: Math.round(new Date().getTime() / 1000).toString(),
  },
  headers: {
    'Content-Type': 'application/json'
  }
})

/**
 * 请求拦截
 */
requestAxios.interceptors.request.use((config: any) => {
  config.headers = {
    'X-Auth-Token': jwtToken,
  }
  return config
})

/**
 * 响应拦截
 */
requestAxios.interceptors.response.use((response: any) => {
  if (response.data && response.data.code == 0) {
    return Promise.resolve(response.data.result)
  } else {
    if (response.data.errorCode == "SECRET_NOT_EXISTS"
      || response.data.errorCode == "ERROR_JWTTOKEN"
      || response.data.errorCode == "TOKEN_EXPIRED"
      || response.data.errorCode == "TOKEN_ILLEGAL"
      || response.data.errorCode == "TOKEN_NULL") {
      window.parent && window.parent.postMessage({type: 'tokenError', value: false}, "*")
    }
    message.error(response.data.errorMessage)
  }
  return Promise.reject(response.data)
}, (error: any) => {
  console.log(error)
  message.error(error.message)
})


export default {
  GET: (url: string, params?: any, data?: any) => {
    return requestAxios.get(url, {
      params,
      data
    })
  },
  DELETE: (url: string, params?: any, data?: any) => {
    return requestAxios.delete(url, {
      params,
      data
    })
  },
  POST: (url: string, data?: any, params?: any) => {
    return requestAxios.post(url, data, {
      params
    })
  },
  PUT: (url: string, data?: any, params?: any) => {
    return requestAxios.put(url, data, {
      params
    })
  }
}
